import { connect } from 'react-redux'
import { removeFrame } from '../../actions/project/frame'
import { IconElement } from '../../components/FrameMenu/index'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(removeFrame()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Remove.js